import { connect } from 'react-redux';
import { ButtonGroup, Button } from '@uhg-uicl/ui-core/dist';
import styled from 'styled-components/macro';
import { push } from 'connected-react-router';
import { PrivacyNoticeRoute, TermsOfUseRoute } from 'constants/routes';

const StyledPrivacyFooter = styled.div`
  .privacy-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 1000;
    box-shadow:
      0px 1px 2px rgba(17, 80, 244, 0.1),
      0px 2px 12px rgba(131, 144, 175, 0.3);
    background-color: #ffffff;
    display: flex;
    justify-content: center;
  }
  .privacy-footer-text {
    color: #5a5a5a;
    font-size: 13px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .privacy-footer-links {
    margin-top: 10px;
    padding-left: 0 !important;
    display: flex;
    color: #5a5a5a;
    font-size: 13px;
    div {
      margin-left: 15px;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .button-text {
    font-size: 13px;
  }
`;

type PrivacyFooterProps = {
  dispatchPush: Function;
};

const PrivacyFooter = ({ dispatchPush }: PrivacyFooterProps) => {
  return (
    <StyledPrivacyFooter>
      <div className="privacy-footer">
        <div className="privacy-footer-text">
          © 2006 - 2026 Optum, Inc. and/or one of its subsidiaries. All rights reserved.
        </div>
        <div className="privacy-footer-links">
          <div
            onClick={() => {
              dispatchPush(PrivacyNoticeRoute);
            }}
          >
            Privacy Policy
          </div>
          <div
            onClick={() => {
              dispatchPush(TermsOfUseRoute);
            }}
          >
            Terms of Use
          </div>
        </div>
      </div>
    </StyledPrivacyFooter>
  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchPush: (location) => dispatch(push(location)),
});
export default connect(mapStateToProps, mapDispatchToProps)(PrivacyFooter);
